import {
  getVendiaResourceFromResourceString,
  matchesVendiaResource,
  ResourceRepresentation,
  VendiaResourceRepresentation,
} from '@vendia/management-api-rbac'
import { ActionEnum, Role } from '@vendia/management-api-types'
import debug from 'debug'

const logger = debug('role-vendia-resource')

export const rolePermitsDataActionVendiaResource = ({
  role,
  action,
  resource,
  enforceEntityAndField = true,
}: {
  role: Role
  action: ActionEnum
  resource: ResourceRepresentation
  enforceEntityAndField?: boolean
}): boolean => {
  if (!resource.startsWith('VendiaResource(')) {
    logger('No VendiaResource provided for action', action)
    return false
  }
  if (!role?.capabilities) {
    logger('No capabilities found for role', role)
    return false
  }
  if (!action?.startsWith('DATA')) {
    logger('No DATA action provided', action)
    return false
  }
  logger('Checking role', role, 'for action', action, 'on resource', resource)

  const targetVendiaResource = getVendiaResourceFromResourceString(resource as VendiaResourceRepresentation)

  const foundMatch = role.capabilities.find((capability) => {
    const actionMatches = capability.action === 'DATA_ALL' || capability.action === action
    const resourceMatches = capability.resources.some((r) => {
      if (!r.startsWith('VendiaResource(')) {
        return false
      }
      const vendiaResource = getVendiaResourceFromResourceString(r as VendiaResourceRepresentation)
      if (!enforceEntityAndField) {
        vendiaResource.entityName = '*'
        vendiaResource.fieldPath = '*'
      }
      return matchesVendiaResource(vendiaResource, targetVendiaResource)
    })
    return actionMatches && resourceMatches
  })

  return Boolean(foundMatch)
}
